import {getBackgroundImageString} from "../helpers/helpers";
import {Button, IconButton} from "@mui/material";
import {
    ArrowDownwardOutlined,
    ArrowUpwardOutlined,
    CenterFocusStrong,
    ContentCopy, DeleteOutline,
    ImageOutlined,
    VideoLibraryOutlined
} from "@mui/icons-material";
import React from "react";
import {createUseStyles} from "react-jss";
import {useScrollytellTranslation} from "../Admin/scrollytellContext";

const useStyles = createUseStyles({
    step: {
        padding: "0 8px",
    },
    stepPreview: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "206px",
        height: "99px",
        gap: "6px",
    },
    stepToolbar: {
        padding: "7px 0",
        display: "flex",
        justifyContent: "space-between",
    },
    stepToolbarLeft: {position: "relative"},
    stepToolbarRight: {},
});

const defaultBackgroundImage = "013AjtNnCUXw";

export const StickySectionSidebarStep = ({
    image,
    background,
    i,
    index,
    onScrollTo,
    onSelectStep,
    onAddBackground,
    onAddImage,
    onAddVideoBackground,
    onAddVideo,
    onMoveUp,
    onMoveDown,
    onSetFocusPickerIndex,
    onDuplicate,
    onDelete,
    isLast
}) => {
    const classes = useStyles();
    const t = useScrollytellTranslation();

    const stepIndex = i ?? index ?? 0;
    const media = image ?? background;
    const handleScroll = () => {
        if (onScrollTo) onScrollTo(stepIndex);
        else if (onSelectStep) onSelectStep(stepIndex);
    };
    const handleAddBg = onAddBackground || onAddImage;
    const handleAddVid = onAddVideoBackground || onAddVideo;

    const handleScrollTo = () => handleScroll();

    const handleScrollAndFocus = () => {
        handleScroll();
        if (onSetFocusPickerIndex) onSetFocusPickerIndex(stepIndex);
    };

    const handleAddBackground = e => {
        e.stopPropagation();
        if (handleAddBg) handleAddBg(stepIndex);
    };

    const handleAddVideoBackground = e => {
        e.stopPropagation();
        if (handleAddVid) handleAddVid(stepIndex);
    };

    const handleMoveUp = () => onMoveUp && onMoveUp(stepIndex);
    const handleMoveDown = () => onMoveDown && onMoveDown(stepIndex);
    const handleDelete = () => onDelete && onDelete(stepIndex);
    const handleDuplicate = () => onDuplicate && onDuplicate(stepIndex);

    const hasMedia = Boolean(media?.image || media?.video);
    const previewMedia = media?.image || media?.video || defaultBackgroundImage;

    return (
        <div className={classes.step} key={`background-image-${stepIndex}`}>
            <h4>
                {`${t(
                    "stickySectionSidebar.stepTitle",
                    "Bakgrunn steg"
                )} ${stepIndex + 1}`}
            </h4>

            <div
                className={classes.stepPreview}
                style={{
                    backgroundImage: getBackgroundImageString(
                        previewMedia,
                        undefined,
                        true,
                        "1024x1024"
                    ),
                    backgroundRepeat: !hasMedia ? "repeat" : "no-repeat",
                    backgroundSize: !hasMedia ? "contain" : "cover",
                }}
                onClick={handleScrollTo}
            >
                <Button
                    onClick={handleAddBackground}
                    size="small"
                    data-testid={`sticky-step-image-btn-${stepIndex}`}
                    sx={{
                        backgroundColor: media?.image ? "#424242" : "#3F51B5",
                        color: "white",
                        minWidth: "auto",
                        fontSize: "11px",
                        padding: "3px 6px",
                    }}
                >
                    <ImageOutlined sx={{ fontSize: "16px", marginRight: "3px" }} />
                    {media?.image
                        ? t(
                            "stickySectionSidebar.updateImageButtonText",
                            "Endre"
                        )
                        : t("stickySectionSidebar.selectImageButtonText", "Bilde")}
                </Button>
                <Button
                    onClick={handleAddVideoBackground}
                    size="small"
                    data-testid={`sticky-step-video-btn-${stepIndex}`}
                    sx={{
                        backgroundColor: media?.video ? "#424242" : "#3F51B5",
                        color: "white",
                        minWidth: "auto",
                        fontSize: "11px",
                        padding: "3px 6px",
                    }}
                >
                    <VideoLibraryOutlined sx={{ fontSize: "16px", marginRight: "3px" }} />
                    {media?.video
                        ? t(
                            "stickySectionSidebar.updateVideoButtonText",
                            "Endre"
                        )
                        : t("stickySectionSidebar.selectVideoButtonText", "Video")}
                </Button>
            </div>
            <div className={classes.stepToolbar}>
                <div className={classes.stepToolbarLeft}>
                    <IconButton
                        sx={{borderRadius: 0, padding: "4px"}}
                        onClick={handleScrollAndFocus}
                        disabled={!media?.image}
                        data-testid={`sticky-step-focus-btn-${stepIndex}`}
                    >
                        <CenterFocusStrong/>
                    </IconButton>
                    <IconButton
                        sx={{borderRadius: 0, padding: "4px"}}
                        onClick={handleMoveUp}
                        disabled={stepIndex <= 0}
                        data-testid={`sticky-step-move-up-btn-${stepIndex}`}
                    >
                        <ArrowUpwardOutlined/>
                    </IconButton>
                    <IconButton
                        sx={{borderRadius: 0, padding: "4px"}}
                        onClick={handleMoveDown}
                        disabled={isLast}
                        data-testid={`sticky-step-move-down-btn-${stepIndex}`}
                    >
                        <ArrowDownwardOutlined/>
                    </IconButton>
                </div>
                <div className={classes.stepToolbarRight}>
                    <IconButton
                        sx={{borderRadius: 0, padding: "4px"}}
                        onClick={handleDuplicate}
                        data-testid={`sticky-step-duplicate-btn-${stepIndex}`}
                    >
                        <ContentCopy/>
                    </IconButton>
                    <IconButton
                        sx={{borderRadius: 0, padding: "4px"}}
                        onClick={handleDelete}
                        data-testid={`sticky-step-delete-btn-${stepIndex}`}
                    >
                        <DeleteOutline/>
                    </IconButton>
                </div>
            </div>
        </div>
    )
}